import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaColors, YodaSpacing } from 'yoda-ui/yodaTheme';

export const mayaMenuStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  flex: '1',
};

export const mayaMenuItemsStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-start',
  gap: YodaSpacing.large,
  paddingLeft: 0,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: '32px',
  marginRight: '32px',
  listStyleType: 'none',

  '@media (max-width:1300px)': {
    gap: YodaSpacing.xxSmall,
  },
};

export const mayaMenuItemStyles: SxProps<Theme> = {
  color: YodaColors.gray8,
};
